import { PropsOf } from '@emotion/react'
import { styled } from '@mui/material'

const StyledSpanWithQuillOverrides = styled('span')(() => ({
  '&.ql-snow .ql-editor': {
    padding: 'inherit',
    margin: 'inherit',
  },
}))

const StyledQuillEditor = styled('span')(() => ({}))

export const SpanWithQuillStyles = (props: PropsOf<typeof StyledSpanWithQuillOverrides>) => {
  const { children, ...restProps } = props
  return (
    <StyledSpanWithQuillOverrides className="ql-snow">
      <StyledQuillEditor className="ql-editor" {...restProps}>
        {children}
      </StyledQuillEditor>
    </StyledSpanWithQuillOverrides>
  )
}
